import { UnconfiguredRules } from "system/types/interfaces";

// These apply to every package, whether or not the catalog returns anything for it, so they
// have to be offered on each path that populates the Default Configurations table.
export const withDefaultConfigurations = (items?: UnconfiguredRules[] | null): UnconfiguredRules[] => {
  const fromCatalog = items ?? [];
  const catalogNames = new Set(fromCatalog.map((item) => item.name));
  return [...defaultConfigurationsForNotConfigured.filter((rule) => !catalogNames.has(rule.name)), ...fromCatalog];
};

// A default configuration applies to every package, so it survives a switch. Reading off
// the same list keeps the two from drifting apart.
export const survivesPackageSwitch = (name?: string | null): boolean =>
  defaultConfigurationsForNotConfigured.some((rule) => rule.name === name);

export const defaultConfigurationsForNotConfigured: UnconfiguredRules[] = [
  {
    name: "Pre-run Command",
    defaultValue: "",
    description: `The PowerShell command(s) to run before running the package. Multiple commands should be separated by a semicolon (;). Must exit with code 0 or 3010 to allow the package to run. Returning 3010 will affect the final return code. Test your command(s) on an endpoint by running: PowerShell.exe -command "<your command>"`,
    type: "string",
    regex: ".*",
  },
  {
    name: "Post-run Command",
    defaultValue: "",
    description: `The PowerShell command(s) to run after running the package. Multiple commands should be separated by a semicolon (;). The PowerShell exit code will affect the final return code. Code 3010 indicates a reboot is required to complete. Test your command(s) on an endpoint by running: PowerShell.exe -command "<your command>"`,
    type: "string",
    regex: ".*",
  },
  {
    name: "max-run-time",
    defaultValue: "0",
    description:
      "May not be specified at the command-line. Limits the amount of time, in minutes, any package is allowed to run, overriding the Client Config default-max-package-run-time value. When the max run time is reached, this process will stop waiting for the currently running package to complete, will allow it to continue, and will attempt to run the next package in the task sequence.",
    type: "long",
    regex: "\\d+",
  },
];
